import { tv } from 'tailwind-variants'

export const actionAlertBarVariants = tv({
  slots: {
    container: 'p-micro bg-info-xdark text-white flex justify-between w-full'
  }
})
